import { callApi2 as callApi } from '@shopee/create-api-request';
import {
  formatMartSearchItemsParameters,
  getStateKey,
  getDefaultShouldSkipCall,
  processRawResponse,
} from './utils';
import * as api from './api';
import { FETCH_MART_SEARCH_ITEMS, COPY_MART_SEARCH_RESULT } from './constants';

// Types
import type {
  MartSearchItemsResponse,
  MartSearchItemsActionRequested,
  MartSearchItemsActionSuccess,
  MartSearchItemsActionFailed,
  MartSearchResult,
  MartCopySearchItemsResult,
  MartSearchItemsParams,
  CustomMartSearchItemsApi,
} from './types';
import type { SearchParams } from '@shopee/search-common-util';

export function fetchMartSearchItems(
  params: MartSearchItemsParams,
  getCustomMartSearchItemsApi?: (
    params: MartSearchItemsParams
  ) => CustomMartSearchItemsApi | undefined
) {
  const {
    searchParams,
    limit,
    offset = 0,
    getStore,
    onFinish,
    shouldSkipCall,
    shouldReset,
  } = params;
  const query = formatMartSearchItemsParameters(searchParams, {
    offset,
    limit,
  });
  const stateKey = getStateKey(searchParams);

  const customMartSearchItemsApi = getCustomMartSearchItemsApi?.(params);

  return callApi<
    MartSearchItemsResponse,
    MartSearchItemsActionRequested,
    MartSearchItemsActionFailed,
    MartSearchItemsActionSuccess
  >({
    apiCall: () =>
      customMartSearchItemsApi
        ? customMartSearchItemsApi(params)
        : api.fetchMartSearchItems(query),
    actions: [
      () => {
        return {
          type: FETCH_MART_SEARCH_ITEMS.REQUESTED,
          payload: {
            key: stateKey,
          },
        };
      },
      (state, response) => {
        return {
          type: FETCH_MART_SEARCH_ITEMS.SUCCESS,
          payload: {
            key: stateKey,
            offset,
            limit,
            result: processRawResponse(response, offset, limit),
            shouldReset,
          },
        };
      },
      (state, response) => {
        return {
          type: FETCH_MART_SEARCH_ITEMS.FAILED,
          payload: {
            key: stateKey,
            error: response.error,
          },
        };
      },
    ],
    shouldSkipCall:
      getStore && !shouldSkipCall
        ? getDefaultShouldSkipCall({ getStore, stateKey, offset, limit })
        : shouldSkipCall,
    onFinish,
  });
}

export function copyMartSearchResult(
  searchParams: SearchParams,
  searchResult: MartSearchResult
): MartCopySearchItemsResult {
  return {
    type: COPY_MART_SEARCH_RESULT,
    payload: {
      key: getStateKey(searchParams),
      result: searchResult,
    },
  };
}
